import Vue from 'vue';
import downLoadVue from './downLoad.vue';
import merge from '@/utils/merge';
import store from '@/store/index';

const defaults = {
    text: '加载中'
};
const DownLoadConstructor = Vue.extend(downLoadVue);

DownLoadConstructor.prototype.close = function() {
    // 动画执行完需要600ms，所以延时关闭 
    return new Promise((resolve) => {
        let timer = null;
        timer = setTimeout(() => {
            if (this._el != null) {
                document.body.removeChild(this._el) //从body中移除dom
            }
            if (this._instance != null) {
                this._instance.$destroy() //销毁组件
            }
            if (this._vm != null) {
                this._vm = null //让GC回收
            }
            if (timer != null) {
                clearTimeout(timer);
            }
            resolve();
        }, 600)
    });
}

DownLoadConstructor.prototype.update = function(percent) {
    if (this._instance != null) {
        this._instance.update(percent)
    }
}

DownLoadConstructor.prototype.updateText = function(text) {
    if (this._instance != null) {
        this._instance.updateText(text)
    }
}

const DownLoad = (options => {
    store.dispatch("setBlueBg", true);
    options = merge({}, defaults, options);
    let instance = new DownLoadConstructor({
        data: options
    });
    instance._vm = instance.$mount()
    instance._el = instance.$el
    instance._instance = instance
    document.body.appendChild(instance.$el) // 把生成的提示的dom插入body中
    return instance;
})

export default DownLoad